module.exports = require("core-js/library/fn/promise");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/promise.js
// module id = 16
// module chunks = 0 1 2 3 4